import TitleOfSection from "../TitleOfSection";
import "./DistinctiveProducts.css";
import React, { useEffect, useState } from "react";
import RightIcon from "../Images/Arrow_right.svg";
import Card from "../../Card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import { Keyboard, Pagination, Navigation } from "swiper/modules";
import { getProductsDistinctiveItems } from "../../../network/api/product.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { link } from "../../../config.js";
import { useTranslation } from "react-i18next";

const DistinctiveProducts = ({ id, update_p, personal }) => {
  const { t } = useTranslation();

  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const getFeaturedItems = async () => {
    try {
      const { data } = await axios.get(`${link}product/featured-items/all/${id}`);

      setProducts(data);
    } catch (error) {
      console.error("Error fetching featured items:", error);
    }
  };

  useEffect(() => {
    // getProductsDistinctiveItems(id).then((results) => {
    //   setProducts(results?.data);
    // });
    getFeaturedItems()
  }, [id]);
  return (
    products.length > 0 && (
      <div className="" style={{ direction: "rtl" }}>
        <div className="container mb-2">
          <div className="d-flex justify-content-between align-items-center">
            <TitleOfSection title={t("featuredCategories")} />
            <div
              onClick={() => navigate(`/distinctiveitems/${id}/1`)}
              className=""
              style={{ cursor: "pointer" }}
            >
          
            </div>
          </div>
        </div>
        <div className="container d-xl-none" style={{ direction: "rtl" }}>
          <Swiper
            slidesPerView={1.5}
            spaceBetween={10}
            breakpoints={{
              500: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2.8,
                spaceBetween: 15,
              },
              880: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1300: {
                slidesPerView: 4.3,
                spaceBetween: 20,
              },
              1400: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
            navigation={true}
            modules={[Keyboard, Pagination, Navigation]}
            className="mySwiper mx-1"
          >
            {products?.filter(p => p.view).map((product, index) => (
              <SwiperSlide className="d-flex flex-column justify-content-center  gap-3 ">
                <Card
                  ImageCard={product.images[0].secure_url}
                  personal={personal}
                  update_p={update_p}
                  brand={product.brand}
                  name={product.name}
                  price={product.price_after}
                  id={product._id}
                  rate={product.averageRating ? product.averageRating : 0}
                  price_after={product.price_after}
                  price_before={product.price_before}
                  product={product}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div
          className="distinctive-products container d-none d-xl-flex gap-4 flex-wrap "
          sty
        >
          {/* <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card />
        <Card /> */}
          {products?.filter(p => p.view).map((product, index) => (
            <Card
              ImageCard={product.images[0].secure_url}
              personal={personal}
              update_p={update_p}
              brand={product.brand}
              name={product.name}
              price={product.price_after}
              id={product._id}
              rate={product.averageRating ? product.averageRating : 0}
              price_after={product.price_after}
              price_before={product.price_before}
              product={product}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default DistinctiveProducts;
